// Dashboard Moderation platform health page translations (en-US), loaded into dashboard.moderation.health by ../en-US.moderation.js
// The spam words stay in pt-BR.health.js, where the functions read them
module.exports = {
  menu: "Platform health",
  title: "Platform Health",
  description: "Moderation, safety and quality of the base.",
  links: {
    users: "Reported users →",
    events: "Reported events →",
  },
  kpis: {
    blocked: "Blocked users",
    reports: "Reports",
    aiFlagged: "Flagged by AI",
    spam: "Spam",
    bans: "Bans",
    deleted: "Deleted users",
    verified: "Verified users",
    duplicates: "Duplicate accounts",
  },
  info: {
    blocked: "Users blocked by other users, on the last day of the period.\nSource: Firebase (blocks between users).",
    reports: "Reports of users and events made in the period.\nSource: Firebase (reports).",
    aiFlagged: "Content flagged by automatic moderation; the apps have no AI moderation yet, so it shows n/a.\nSource: no source for now.",
    spam: "Reports of the period whose reason points to spam.\nSource: Firebase (reports).",
    bans: "Accounts blocked by the admins, today (blocks have no date).\nSource: Firebase (user profiles).",
    deleted: "Accounts deleted in the period; the ones deleted before the date started being recorded do not count.\nSource: Firebase (user profiles).",
    verified: "Verified users; the apps have no verification yet, so it shows n/a.\nSource: no source for now.",
    duplicates: "Accounts created in the period with an e-mail another account already used.\nSource: Firebase (e-mail index of the accounts).",
  },
  hints: {
    bans: "accounts blocked by the admin, today",
    duplicates: "same email as another account",
    deletedSince: "counted since {date}",
  },
  unavailable: {
    aiFlagged: "the app has no AI flagging yet",
    verified: "the app has no user verification yet",
    deleted: "the date of the deletions is recorded from now on",
    deletedPanel: "The date of the deletions is recorded from now on; earlier deletions have no date.",
  },
  curation: {
    approved: "Approved",
    removed: "Removed",
    pending: "Under review",
    sub: "reports",
  },
  reasons: {
    others: "Other reasons",
  },
  panels: {
    signals: "Reports and flags by {gran}",
    curation: "Curation decision",
    curationNote: "Status of the user and event reports of the period: approved when the report is rejected, removed when it is accepted.",
    reasons: "Report reasons",
    reasonsNote: "Text written by the reporter: the 6 most repeated in the period.",
    deleted: "Deleted accounts by {gran}",
  },
  panelInfo: {
    signals: "Reports of users and events in each interval.\nSource: Firebase (reports).",
    curation: "Status of the reports of the period: approved, removed or under review.\nSource: Firebase (reports).",
    reasons: "Reasons written the most in the reports of the period.\nSource: Firebase (reports).",
    deleted: "Accounts deleted in each interval.\nSource: Firebase (user profiles).",
  },
};
